import SearchIcon from '../../../atoms/icons/search-icon'
import XIcon from '../../../atoms/icons/x-icon'

const BHSearch = {
	BHSearch: {
		defaultProps: {
			priceProps: {
				showPercentage: true,
			},
			textFieldProps: {
				EndIcon: XIcon,
				inputProps: {
					type: 'search',
				},
				name: 'search',
				StartIcon: SearchIcon,
			},
			wishListProps: {
				position: 'outer',
				variant: 'icon',
			},
		},
	},
}

export default BHSearch
